/**
 * @generated SignedSource<<6a214c84b3fc824df5789057f2c9ceb2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type trackSeoTests_abTestConfigV2UserVariant$data = {
  readonly config: {
    readonly testName: string | null;
  } | null;
  readonly variant: string | null;
  readonly " $fragmentType": "trackSeoTests_abTestConfigV2UserVariant";
};
export type trackSeoTests_abTestConfigV2UserVariant$key = {
  readonly " $data"?: trackSeoTests_abTestConfigV2UserVariant$data;
  readonly " $fragmentSpreads": FragmentRefs<"trackSeoTests_abTestConfigV2UserVariant">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "trackSeoTests_abTestConfigV2UserVariant"
};

(node as any).hash = "9af5263792a93d2c5a806c95eb40313c";

export default node;
